<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectPauseReason,
} from '../../../../model/additional-info/support/info-pause-subscription/select-pause-reason.hook'

defineOptions({
  name: 'SelectPauseReason',
})

const {
  placeholder,
  model,
  options,
} = useSelectPauseReason()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
